// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"fcaddd2b","455":"f18d01e6","488":"e75445ad","977":"ce2eb3e4"}[chunkId] + ".chunk.js";
};